const PINTEREST_BASE_SCRIPT_ID = 'pinterest-tag-base';

/**
 * Injeta o script base do Pinterest Tag (apenas uma vez)
 */
const ensurePinterestBaseLoaded = (): void => {
  if (document.getElementById(PINTEREST_BASE_SCRIPT_ID)) return;
  if (typeof window !== 'undefined' && (window as any).pintrk) return;

  const baseScript = `
    !function(e){if(!window.pintrk){window.pintrk=function(){window.pintrk.queue.push(Array.prototype.slice.call(arguments))};var n=window.pintrk;n.queue=[],n.version="3.0";var t=document.createElement("script");t.async=!0,t.src=e;var r=document.getElementsByTagName("script")[0];r.parentNode.insertBefore(t,r)}}("https://s.pinimg.com/ct/core.js");
  `;

  const script = document.createElement('script');
  script.id = PINTEREST_BASE_SCRIPT_ID;
  script.innerHTML = baseScript;
  document.head.appendChild(script);
};

/**
 * Inicializa o Pinterest Tag para um Tag ID
 * Nota: o parâmetro `em` (email) é opcional e geralmente é usado/hasheado em integrações mais completas.
 * Para o MVP, carregamos apenas o Tag ID e disparamos page().
 */
export const initializePinterestTag = (tagId: string): boolean => {
  if (!tagId) return false;

  try {
    ensurePinterestBaseLoaded();
    const pintrk = (window as any).pintrk;
    if (pintrk) {
      pintrk('load', tagId);
    }
    return true;
  } catch (error) {
    console.error(`❌ Pinterest Tag - Erro ao inicializar ${tagId}:`, error);
    return false;
  }
};

